module.exports = __webpack_public_path__ + "images/emoji/rugby_football.3fa958b72884344b038f.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/rugby_football.png
// module id = G5/3
// module chunks = 14